// extracted by mini-css-extract-plugin
export default {"presentation-wrapper":"GamePresentation_presentation-wrapper__VIpe1","video-container":"GamePresentation_video-container__2nYNK"};